import {
	Component,
	OnDestroy,
	OnInit,
	TemplateRef,
	ViewChild,
	Input,
} from "@angular/core";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { Subject } from "rxjs";
import { CommonService } from "../../common.service";
import { Router, ActivatedRoute } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { DataTableDirective } from "angular-datatables";
import { DatePipe, TitleCasePipe } from "@angular/common";
import * as moment from "moment";
import { SearchPipe } from "../../_pipe/search/search.pipe";
import { CommonVariablesService } from "../../common-variables.service";
import { SelectDropDownComponent } from "ngx-select-dropdown";
import { IDropdownSettings } from "ng-multiselect-dropdown";
import {
	FormGroup,
	FormBuilder,
	FormControl,
	Validator,
	Validators,
} from "@angular/forms";
@Component({
	selector: "app-declaration-tbl",
	templateUrl: "./declaration-tbl.component.html",
	styleUrls: ["./declaration-tbl.component.css"],
})
export class DeclarationTblComponent implements OnInit, OnDestroy {
	@ViewChild("multiSelect") multiSelect;
	channelTypeForm: FormGroup;
	@ViewChild(DataTableDirective, { static: false })
	dtElement: DataTableDirective;
	@Input("masterPolicyId") masterPolicyId: string;
	@Input("getUserType") getUserType: string;
	@Input("policyRenewalCounter") policyRenewalCounter: string;
	@ViewChild(SelectDropDownComponent, { static: false })
	ngxselectRef: SelectDropDownComponent;
	dropdownSettings: IDropdownSettings = {};
	// @Input('isMasterPolicyInactived') isMasterPolicyInactived: boolean;
	select_ChannelType: any = [];
	select_Status: any = [];
	//helpdesk filter
	statusForm:FormGroup;
	oop_select_Status:any=[];
	policyNumber: any;
	sessionalData:any;
	selected: string;
	oneAtATime = true;
	modalRef: BsModalRef;
	config: any = { class: "theme-modal right modal-sm", backdrop: "static" };
	isShow: any;
	isBulk = false;
	dtOptions: DataTables.Settings = {};
	declarationData: any = {
		contentData: [],
	};
	public settings = {};
	public settingsForStatus = {};
	//helpdesk filter
	public settingForOPSstatus = {};
	dtTrigger: Subject<any> = new Subject();
	// dtTrigger1: Subject<any> = new Subject();
	pageContent: number;
	certificateData: any = [];
	pageSubscription: any;
	totalCertificateData: any;
	header: any;
	expression: any = [];
	modelResponse: any;
	cancelCert: any = {};
	tableEmptyMsg = "No Records available";
	isUwCertificate: boolean = false;
	minIssueDate: any;
	maxIssueDate: any;
	totalDeclarationData: any;
	gcEndorsementDetails: any;
	gcPolicyDetails: any;
	isMasterPolicyInactived: boolean = false;
	observableSubscription: any;
	isBulkPolicyInactived: boolean = false;
	drop_downSettings: IDropdownSettings = {};
	public name = "";
	submitted: boolean = false;
	certificateDraftHistoryForm: FormGroup;
	isShowCertificateDate: boolean = true;
	isShowCertificateTxt: boolean = false;
	masterPolicyRenewalCounter: any;

	constructor(
		private modalService: BsModalService,
		public commonService: CommonService,
		public commonVariablesService: CommonVariablesService,
		private activatedRoute: ActivatedRoute,
		private spinner: NgxSpinnerService,
		private router: Router,
		private datePipe: DatePipe,
		private titlecasePipe: TitleCasePipe,
		private searchPipe: SearchPipe,
		private formBuilder: FormBuilder
	) {}

	async ngOnInit() {
		window.onunload = function () {
			sessionStorage.removeItem("sessionalData");
		};
		this.select_Status = [];
		/* this.select_Status.push(
      { txtStatus: 'Cancel Certificate - Pending', statusVal: 'open' },
      { txtStatus: 'Cancel Certificate - Approved', statusVal: 'approved' },
      { txtStatus: 'Cancel Certificate - Rejected', statusVal: 'rejected' },
      { txtStatus: 'Others - Pending', statusVal: '' },
      { txtStatus: 'Others - Approved', statusVal: 'approve' },
      { txtStatus: 'Others - Rejected', statusVal: 'reject' }
    ); */
		this.select_Status.push(
			{ txtStatus: "Cancel Certificate - Pending", statusVal: "open" },
			{ txtStatus: "Cancel Certificate - Action Taken", statusVal: "approved" },
			{ txtStatus: "Others - Pending", statusVal: "pending" },
			{ txtStatus: "Others - Action Taken", statusVal: "actiontaken" }
		);
		//helpdesk filter
		this.oop_select_Status.push(
 
			{ txtStatus: "Cancel Certificate - Pending", statusVal:"open"},
			{ txtStatus: "Cancel Certificate - Action Taken", statusVal:"approved"},
		);

		/* added by obulakshmi. description: impersonate */
		sessionStorage.removeItem("imp_token");
		sessionStorage.removeItem("impersonate_user");
		/* end */

		this.dtOptions = {
			dom: "ftipr",
			destroy: true,
			pageLength: 25,
			language: {
				emptyTable: this.tableEmptyMsg,
			},
		};
		this.channelTypeForm = this.formBuilder.group({
			channelType: ["", Validators.required],
			selStatus: ["", Validators.required],
			policy_number: ["", Validators.minLength(10)],
		});
		//helpdesk filter
		this.statusForm = this.formBuilder.group({
 
			ops_selStatus: ["", Validators.required],
			ops_policy_number: ["", Validators.minLength(10)],

			});

		var temp = new Date();
		temp.setDate(temp.getDate() - 6);
		this.certificateDraftHistoryForm = this.formBuilder.group({
			certificateFromDate: [temp],
			certificateToDate: [new Date()],
			certificateDraftHistory: ["Issue Date"],
			certificateTxt: [""],
		});
		this.selectCertificateFilterType();

		this.settings = {
			singleSelection: false,
			idField: "channel_type",
			textField: "channel_type",
			enableCheckAll: true,
			selectAllText: "select All",
			unSelectAllText: "",
			allowSearchFilter: true,
			limitSelection: -1,
			clearSearchFilter: true,
			maxHeight: 197,
			itemsShowLimit: 3,
			searchPlaceholderText: "select channel type",
			noDataAvailablePlaceholderText: "No data available",
			closeDropDownOnSelection: false,
			showSelectedItemsAtTop: false,
			defaultOpen: false,
		};
		
		
		this.settingsForStatus = {
			singleSelection: true,
			idField: "statusVal",
			//limitSelection:1,
			textField:"txtStatus",
			selectAllText: "Select All",
			unSelectAllText: "UnSelect All",
			allowSearchFilter: true, //this.ShowFilter
		  };
		  //helpdesk filter
		  this.settingForOPSstatus = {
 
			singleSelection: true,

			idField: "statusVal",

			//limitSelection:1,

			textField:"txtStatus",

			selectAllText: "Select All",

			unSelectAllText: "UnSelect All",

		  };

		const tmpUrl: any = this.router.url.split("/");
		this.observableSubscription =
			await this.commonService.asObservable.subscribe(async (user) => {
				this.spinner.show();
				setTimeout(async () => {
					const datas = user || { id: tmpUrl[2] };
					if (
						!(
							((this.pageContent == 0 && Number(datas.id) == 1) ||
								(this.pageContent == 1 && Number(datas.id) == 0)) &&
							(this.getUserType == "underwriter" ||
								this.getUserType == "helpdesk")
						)
					) {
						$("#declaration_table").DataTable().destroy();
						this.spinner.show();
						await this.onLoadFunctionality(datas);
					}
					$("#declaration_table").DataTable().destroy();

					let data;

		 data = JSON.parse(sessionStorage.getItem("sessionalData"));
 
		 if (data) {

			var x = document.getElementById('btnChannelTypeSubmit');
			if(x !== null) {
				x.setAttribute('disabled','true')
			}
			 console.log("abc")
 
			 this.select_Status=[];
 
						 this.select_Status.push(
 
							 { txtStatus: "Cancel Certificate - Pending", statusVal: "open" },
 
							 { txtStatus: "Cancel Certificate - Action Taken", statusVal: "approved" },
 
							 { txtStatus: "Others - Pending", statusVal: "pending" },
 
							 { txtStatus: "Others - Action Taken", statusVal: "actiontaken" }
 
							 );
 
			 this.channelTypeForm?.get("channelType")?.setValue(data?.channel);
 
			 this.channelTypeForm?.get("selStatus")?.setValue(data?.status);
 
			 this.channelTypeForm?.get("policy_number")?.setValue(data?.policy);

			 setTimeout(() => {
				$("#declaration_table").DataTable().destroy();
				 this.selectChannelType(data?.channel, data?.status, data?.policy || "");

				 setTimeout(() => {
					 if(x !== null)
					 	x.removeAttribute('disabled');
				 }, 5000);
 
			 }, 4500);


			 
 
			 }
				}, 500);
			});

		this.pageSubscription = this.activatedRoute.params.subscribe(
			async (val) => {
				// await this.onLoadFunctionality(val);
				if (val.id != 0 && val.id != 1) {
					await this.onLoadFunctionality(val);
				}
				// (val.id != 0 && val.id != 1) ? await this.onLoadFunctionality(val) : '';
			}
		);
		/* const header = JSON.parse(window.localStorage.getItem('declaration-header') || '{}');
    if (header.header_policy == this.header.policy) {
      await this.onLoadFunctionality({ id: 1 });
    } */
		// Display search without table data - this.pageContent = 0;
		// Display search table data - this.pageContent = 1;
		// Display selected policy details - this.pageContent = 2;
		// Draft pdf - this.pageContent = 3;
		// Issue Certificate - this.pageContent = 4;
		// bulk declaration detailed page - this.pageContent = 5;
		// Generated Certificate page - this.pageContent = 6;
		// Update Certificate UW - this.pageContent = 7;
		// Update Draft - this.pageContent = 8;
		
		
	}
	get f() {
		return this.channelTypeForm.controls;
	}
	//helpdesk filter
	get m(){
		return this.statusForm.controls
	}
	get certificateHistoryForm() {
		return this.certificateDraftHistoryForm.controls;
	}
	ngOnDestroy() {
		if (this.pageSubscription) {
			this.pageSubscription.unsubscribe();
		}
		// this.pageSubscription ? this.pageSubscription.unsubscribe() : '';
		if (this.dtTrigger) {
			this.dtTrigger.unsubscribe();
		}
		// this.dtTrigger ? this.dtTrigger.unsubscribe() : '';
		// this.dtTrigger1 ? this.dtTrigger1.unsubscribe() : '';
		if (this.observableSubscription) {
			this.observableSubscription.unsubscribe();
		}
		// this.observableSubscription ? this.observableSubscription.unsubscribe() : '';
		$.fn["dataTable"].ext.search.pop();
	}

	/*
	 * Created By : Sharann N
	 * Description : open modal template.
	 *********************************************/
	async openModal(template: TemplateRef<any>, text) {
		if (this.header.tp_policy_no != "") {
			const modelTitle = text;
			this.isBulk = false;
			this.selected = "";
			if (modelTitle == "bulk") {
				this.isBulk = true;
			}
			await this.loadCertificateTableData(modelTitle)
				.then((res) => {
					// this.dtTrigger1.next();
				})
				.catch((err) => {});
			if (this.modelResponse.status == 0) {
				this.modalRef = await this.modalService.show(template, this.config);
				this.spinner.hide();
				setTimeout(() => {
					this.spinner.hide();
				}, 7000);
			}
		} else {
			this.commonService.errorsmsg("Please select master policy no", "");
		}
	}

	/*
	 * Created By : Sharann N
	 * Description : datatable customize filter for column.
	 *********************************************/
	filterById(idx, isCertificateTbl, event: any = ""): void {
		this.spinner.show();
		const table = isCertificateTbl
			? $("#certificate_table").DataTable()
			: $("#declaration_table").DataTable();
		const dateIdxAry = isCertificateTbl ? [7, 8, 11, 12] : [3, 6];
		const len = isCertificateTbl ? 15 : 12;
		if (event) {
			table.destroy();
			let content = "";
			for (var i = 1; i <= len; i++) {
				if (i == idx) continue;
				content += +$("#" + i).val();
			}
			const tempArray = content
				? this.declarationData.contentData
				: this.totalDeclarationData;
			const field =
				idx == "3" || idx == "11"
					? "certificate_date_obj"
					: idx == "6"
					? "req_date_obj"
					: idx == "7"
					? "invoice_date_obj"
					: idx == "8"
					? "issue_date_obj"
					: idx == "12"
					? "valid_upto_obj"
					: "";
			event[0] = new Date(
				this.datePipe.transform(event[0], "yyyy-MM-dd") + "T00:00:00Z"
			);
			event[1] = new Date(
				this.datePipe.transform(event[1], "yyyy-MM-dd") + "T00:00:00Z"
			);
			this.declarationData.contentData = tempArray.filter((item: any) => {
				item[field] =
					item[field] != "-"
						? new Date(
								this.datePipe.transform(item[field], "yyyy-MM-dd") +
									"T00:00:00Z"
						  )
						: "-";
				return (
					new Date(item[field]).getTime() >= event[0].getTime() &&
					new Date(item[field]).getTime() <= event[1].getTime()
				);
			});
			/* let value = this.datePipe.transform(event[0],'dd-MM-yyyy')+' - '+this.datePipe.transform(event[1],'dd-MM-yyyy') */
			/* table.column(idx).search(value).draw(); */
			this.dtTrigger.next();
		} else {
			let hasValue = 0;
			table.search("").columns().search("").draw();
			for (let index = 1; index < len; index++) {
				let value = ($(`#${index}`).val() || "").toString().toLowerCase();
				if (value != "") {
					hasValue++;
					if (dateIdxAry.indexOf(index) == -1) {
						table.column(index).search(value).draw();
					}
				}
			}
			if (hasValue == 0) {
				this.declarationData.contentData = this.totalDeclarationData;
				table.destroy();
				this.dtTrigger.next();
			}
		}
		this.spinner.hide();
		setTimeout(() => {
			this.spinner.hide();
		}, 7000);
	}

	rerender(): void {
		var container = document.getElementById("declaration_table");
		var content = container.innerHTML;
		container.innerHTML = content;
		/* this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    }); */
	}

	/*
	 * Created By : Sharann N
	 * Description : to load the certificate and assigned declaration in declaration table.
	 *********************************************/
	async loadCompleteDeclarationData() {
		this.spinner.show();
		this.declarationData = {
			contentData: [],
		};
		let url;
		const selectedPolicyNo = (this.header || {}).tp_policy_no || "";
		//Priyadharshini Channel Type
		if (this.getUserType == "underwriter" && this.pageContent == 0) {
			//await this.selectChannelType([])   //Priyadharshini - Channel Type
			/***************ragu */
			url = `${this.commonVariablesService.baseURL}api/v1/marine_declaration/all_producer_channel`;

			const resp = await this.commonService.httpGetMethod(
				url,
				"application/json",
				true,
				"",
				"Declaration"
			);
			if (resp.status == 0) {
				const responseData = resp.data;
				// this.select_ChannelType = responseData;
				setTimeout(async () => {
					this.select_ChannelType = responseData;
				}, 600);
				this.dtTrigger.next();
			} else if (resp.status != -114) {
				this.commonService.errorsmsg(
					"Unable load Generated Certificate List",
					""
				);
			}
		}
		/*****end */
		if (this.getUserType == "helpdesk" && this.pageContent == 0) {
			await this.loadCancelCertificateList("", [
				"rejected",
				"approved",
				"open",
			]);
		}
		if (
			!(
				(this.getUserType == "underwriter" && this.pageContent == 0) ||
				(this.getUserType == "helpdesk" && this.pageContent == 0)
			)
		) {
			this.declarationData.contentData = [];
			$("#certificate_table").DataTable().destroy();
			await this.loadDraftCertificateList(selectedPolicyNo);
			this.dtTrigger.next();
		}
		this.totalDeclarationData = this.declarationData.contentData;
		this.declarationData.contentData = this.declarationData.contentData.sort(
			function (a, b) {
				return new Date(a.req_date_obj).getTime() <
					new Date(b.req_date_obj).getTime()
					? 1
					: new Date(a.req_date_obj).getTime() ==
					  new Date(b.req_date_obj).getTime()
					? 0
					: -1;
			}
		);
		//bot issue start
		let data;
		data = JSON.parse(sessionStorage.getItem("sessionalData"));
		const tmpUrl: any = this.router.url.split("/");
		if(data){
			this.spinner.show()
		}else{	
			setTimeout(() => {
				this.spinner.hide();
			}, 7000)
		}
		//bot issue end
	}

	async selectChannelType(val:any="", statusVal, policy_no: any = "") {
		
		const tmpUrl: any = this.router.url.split("/");
		var x = document.getElementById('btnChannelTypeSubmit');
			if(x !== null) {
				x.setAttribute('disabled','true')
		}
		if(tmpUrl[2] == "0") {
		this.spinner.show();
		//helpdesk filter
		if(this.getUserType !="helpdesk"){
		if (this.channelTypeForm.invalid) {
			this.submitted = true;
			return;
		}
	}if(this.getUserType == "helpdesk"){
		if (this.statusForm.invalid) {
			this.submitted = true;
			return;
		}
	}
	if(this.getUserType !="helpdesk"){
		this.sessionalData = {
			channel: val,
			status: statusVal,
			policy: policy_no,
		};
		sessionStorage.setItem("sessionalData", JSON.stringify(this.sessionalData));}
		const newArray = [];
		let statusArrayForUW = [];
		let statusArrayForList = [];
		let flagForList = false;
		let flagForUWList = false;
		for (var i = 0; i < val.length; i++) {
			newArray.push(val[i].channel_type);
		}

		for (let count = 0; count < statusVal.length; count++) {
			// if (statusVal[count].statusVal == 'open' || statusVal[count].statusVal == 'approved' || statusVal[count].statusVal == 'rejected') {
			if (statusVal[count].statusVal == "open") {
				flagForList = true;
				statusArrayForList.push(statusVal[count].statusVal);
			} else if (statusVal[count].statusVal == "approved") {
				flagForList = true;
				statusArrayForList.push("approved");
				statusArrayForList.push("rejected");
			} else {
				flagForUWList = true;

				if (statusVal[count].statusVal == "pending") {
					statusArrayForUW.push("pending");
					// statusArrayForUW.push('approve');
					// statusArrayForUW.push('approved');
				}
				// else if (statusVal[count].statusVal == 'reject') {
				//   statusArrayForUW.push('reject');
				//   statusArrayForUW.push('rejected');
				// }
				else {
					// statusArrayForUW.push(statusVal[count].statusVal);
					statusArrayForUW.push("actiontaken");
				}
			}
		}

		$("#declaration_table").DataTable().destroy();
		this.spinner.show();
		this.declarationData = {
			contentData: [],
		};
		let url;
		const selectedPolicyNo = (this.header || {}).tp_policy_no || "";
		if (
			this.getUserType == "underwriter" &&
			this.pageContent == 0 &&
			flagForUWList == true
		) {
			url = `${this.commonVariablesService.baseURL}api/v1/marine_declaration/uw_policy_list`;
			const params = {
				//product_id: this.commonVariablesService.declarationProductId,
				//email: (window.localStorage.getItem('email') || ''),
				uw_location: window.localStorage.getItem("uwLevelObj") || "{}",
				channel_type: newArray,
				status_selected: statusArrayForUW,
				gc_policy_no: policy_no,
			};

			const response = await this.commonService.httpPostMethod(
				url,
				params,
				"application/json",
				true,
				"Declaration"
			);

			this.spinner.show();
			this.declarationData = {
				contentData: [],
			};
			if (response.body.status === 0) {
				const responseData = response.body.data;
				this.declarationData.contentData = [];
				if (responseData) {
					await this.assignToTable(responseData);

					if (flagForList == false) {
						this.dtTrigger.next();
					}
				}
			} else if (response.body.status != -114) {
				this.commonService.errorsmsg(
					"Unable load Generated Certificate List",
					""
				);
			}
		}
		if (
			(this.getUserType == "underwriter" &&
				this.pageContent == 0 &&
				flagForList == true)
		) {
			await this.loadCancelCertificateList(
				newArray,
				statusArrayForList,
				policy_no
			);
			this.dtTrigger.next();
		}
		//helpdesk filter
		if 
 			(this.getUserType == "helpdesk" &&
 				this.pageContent == 0
 				)
  {
 			await this.loadCancelCertificateList(
 				"",
 				statusArrayForList,
 				policy_no
 			);
 			this.dtTrigger.next();
 		}

		this.totalDeclarationData = this.declarationData.contentData;
		this.declarationData.contentData = this.declarationData.contentData.sort(
			function (a, b) {
				return new Date(a.req_date_obj).getTime() <
					new Date(b.req_date_obj).getTime()
					? 1
					: new Date(a.req_date_obj).getTime() ==
					  new Date(b.req_date_obj).getTime()
					? 0
					: -1;
			}
		);


		setTimeout(() => {
			if(x !== null)
				x.removeAttribute('disabled');
		}, 6500);

		setTimeout(() => {
			this.spinner.hide();
		}, 7000);
	}
	}
	/*
	 * Created By : Balbir Kaur
	 * Description : allow only numbers
	 *********************************************/
	numberOnly(event): boolean {
		const charCode = event.which ? event.which : event.keyCode;
		if (charCode > 31 && (charCode < 48 || charCode > 57)) {
			return false;
		}
		return true;
	}
	/*
	 * Created By : Sharann N
	 * Description : to find declaration type of declaration.
	 *********************************************/
	async findDeclarationType(gcData, coiData, coiData1: any = "") {
		let bulkType = "";
		for (const obj of gcData.data.sub_voyage) {
			if (
				(obj.id == coiData.quote.data.sub_voyage_id ||
					obj.sub_voyage_name == coiData.quote.data.sub_voyage_type) &&
				gcData.quote.data.voyage.voyage_name == coiData.quote.data.voyage_name
			) {
				bulkType = `${
					((obj.certificate_bulk || "").toLowerCase() == "certificate"
						? gcData.data.declaration_type_sub_voyage
						: obj.certificate_bulk) +
					" " +
					obj.bulk_declaration_type
				}`;
				break;
			}
		}
		const declType = bulkType == "" ? coiData.quote.cust_fld_2 : bulkType;
		return declType;
	}

	/*
	 * Created By : Sharann N
	 * Description : to load the certificate and bulk declaration table.
	 *********************************************/
	async loadCertificateTableData(type, forTableView = true) {
		let allPolicyRefNum = window.localStorage.getItem("allPolicyrefNum");
		/* console.log(allPolicyRefNum) */
		const url =
			this.commonVariablesService.baseURL +
			"api/v1/marine_declaration/master_policy";
		const paramData = {
			product_id: this.commonVariablesService.declarationProductId,
			gc_policy_no: this.header.tp_policy_no,
			policy_ref_num: allPolicyRefNum,
			/* all_policy_ref_num: allPolicyRefNum */
		};
		this.modelResponse = await this.commonService.httpGetMethod(
			url,
			"application/json",
			true,
			paramData,
			"Declaration"
		);
		this.totalCertificateData =
			this.modelResponse.status == 0 ? this.modelResponse.data || [] : [];
		this.spinner.show();
		let tempArrObj = [];

		tempArrObj = await this.formActiveMasterPolicies(type, forTableView);

		this.certificateData = JSON.parse(JSON.stringify(tempArrObj));
		if (forTableView) {
			// $('#certificate_table').DataTable().destroy();
			// this.dtTrigger1.next();
		}
	}

	/*
	 * Created By : Sharann N
	 * Description : navigate to child component.
	 *********************************************/
	async goToChild(data, pageId) {
		this.closeModal();
		// const header = JSON.parse(window.localStorage.getItem('declaration-header') || '{}');
		// const declarationHeader: any = {};
		const declarationHeader: any = JSON.parse(
			window.localStorage.getItem("declaration-header") || "{}"
		);
		declarationHeader.tp_policy_no = data.cust_fld_1 || "";
		declarationHeader.insured_name = data.insured_name || "";
		declarationHeader.insured_city = data.insured_branch || "";
		declarationHeader.policy_id = data.policy_id || "";
		declarationHeader.quote_id = data.quote_id || "";
		declarationHeader.header_policy = data.cust_fld_1 || "";
		declarationHeader.policy_no = data.policy_no || "";
		declarationHeader.sub_voyage_id = data.sub_voyage_id || 0;
		declarationHeader.prev_sub_voyage_id = data.sub_voyage_id || 0;
		declarationHeader.nav_to = "";
		declarationHeader.masterpolicy_status = data.masterpolicy_status || 0;
		declarationHeader.certificate_status = "";
		// Ticket No : 176527 Same voyage name changes start
		declarationHeader.gc_running_id = data.gc_running_id;
		declarationHeader.risk_detail_serial = data.risk_details_serial;
		window.localStorage.setItem(
			"declaration-header",
			JSON.stringify(declarationHeader)
		);
		this.gotoPageContent(pageId);
	}

	/*
	 * Created By : Sharann N
	 * Description : page onload functionalities.
	 *********************************************/
	async onLoadFunctionality(data) {
		this.header = JSON.parse(
			window.localStorage.getItem("declaration-header") || "{}"
		);
		const tmpUrl = this.router.url.split("/");
		this.pageContent = Number(tmpUrl[2] == "0" ? tmpUrl[2] : data.id) || 0;
		this.declarationData = {
			contentData: [],
		};
		$("#certificate_table").DataTable().destroy();
		this.dtTrigger.next();
		if (this.pageContent == 1 && this.header.policy_no) {
			this.gcPolicyDetails = await this.getPolicyData(
				{ tp_policy_no: this.header.policy_no },
				true
			);
			// if (((((this.gcPolicyDetails || {}).quote || {}).data || {}).gc_policy_start_date || '') != '') {
			//   this.minIssueDate = new Date(this.gcPolicyDetails.quote.data.gc_policy_start_date);
			// }
			// if (((((this.gcPolicyDetails || {}).quote || {}).data || {}).gc_policy_end_date || '') != '') {
			//   this.maxIssueDate = new Date(this.gcPolicyDetails.quote.data.gc_policy_end_date);
			// }
			if (this.header.header_policy) {
				this.gcEndorsementDetails =
					await this.commonService.getMasterEndorsement(
						this.header.header_policy,
						this.policyRenewalCounter
					);
			}
		}

		let bulkArr = [];
		if (
			this.pageContent == 1 ||
			(this.pageContent == 0 &&
				(this.getUserType == "underwriter" || this.getUserType == "helpdesk"))
		) {
			if (this.header.tp_policy_no) {
				await this.loadCertificateTableData("certificate", false);
				bulkArr = await this.formActiveMasterPolicies("bulk", false);
			}
			this.isMasterPolicyInactived =
				this.certificateData.length == 0 ? true : false;
			this.isBulkPolicyInactived = bulkArr.length == 0 ? true : false;
			//this.declarationData.contentData = []
			$("#declaration_table").DataTable().destroy();
			$("#certificate_table").DataTable().destroy();
			setTimeout(async () => {
				await this.loadCompleteDeclarationData();
				this.dtTrigger.next();
			}, 1000);
			// await this.rerender();
		}

		// this.pageSubscription ? this.pageSubscription.unsubscribe() : '';
		// this.observableSubscription ? this.observableSubscription.unsubscribe() : '';
	}

	/*
	 * Created By : Sharann N
	 * Description : navigate to child component.
	 *********************************************/
	async gotoPageContent(pageId) {
		await this.commonService.navigateToDecl(pageId);
	}

	/*
	 * Created By : Sharann N
	 * Description : navigate to child component.
	 *********************************************/
	async navigateTo(idx, data) {
		if (
			data.valueText != "view_cert" &&
			data.valueText != "view_draft_cert" &&
			data.valueText != "history" &&
			data.valueText != "view_bulk"
		) {
			let res = await this.checkMasterPolicy(
				this.declarationData.contentData[idx]
			);
			res = res == false ? await this.checkAssignee(idx) : res;
			if (res) {
				return;
			}
		}
		let header = JSON.parse(
			window.localStorage.getItem("declaration-header") || "{}"
		);
		header.quote_id = this.declarationData.contentData[idx].quote_id;
		header.policy_id = this.declarationData.contentData[idx].policy_id;
		header.policy_no = this.declarationData.contentData[idx].master_policy_no;
		header.tp_policy_no = this.declarationData.contentData[idx].policy_no;
		header.sub_voyage_id = this.declarationData.contentData[idx].sub_voyage_id;
		header.prev_sub_voyage_id =
			this.declarationData.contentData[idx].sub_voyage_id;
		header.nav_to = data.valueText;
		header.dup_cert_policy_no =
			this.declarationData.contentData[idx].dup_cert_policy_no || "";
		header.reason = this.declarationData.contentData[idx].client_remarks || "";
		header.referral_type =
			this.declarationData.contentData[idx].referral_type || "";
		header.certificate_status =
			this.declarationData.contentData[idx].status ||
			this.declarationData.contentData[idx].uw_status ||
			"";
		header.uw_case =
			(this.declarationData.contentData[idx].uw_status || "") != ""
				? true
				: false;
		header.actual_renewal_counter =
			(this.masterPolicyRenewalCounter
				? this.masterPolicyRenewalCounter
				: this.policyRenewalCounter) || "000";
		//header.actual_renewal_counter = this.masterPolicyRenewalCounter  || '000';
		/* sessionStorage.setItem('declaration-header', JSON.stringify(header)); */
		window.localStorage.setItem("declaration-header", JSON.stringify(header));
		this.gotoPageContent(data.navTo);
	}

	/*
	 * Created By : Sharann N
	 * Description : to close modal template.
	 *********************************************/
	closeModal() {
		if (this.modalRef) {
			this.modalRef.hide();
		}
	}

	/*
	 * Created By : Sharann N
	 * Description : to close certificate/bulk modal template.
	 *********************************************/
	async closeCertificateModal() {
		// $('#certificate_table').remove();
		// this.dtTrigger1 ? this.dtTrigger1.unsubscribe() : '';
		this.closeModal();
	}

	/*
	 * Created By : Sharann N
	 * Description : to get policy details.
	 *********************************************/
	async getPolicyData(policy, isPolicyNo: boolean = false) {
		const url = `${this.commonVariablesService.baseURL}api/v1/policy`;
		let paramData = {};
		isPolicyNo
			? (paramData["policy_no"] =
					policy.tp_policy_no || policy.master_policy_no)
			: (paramData["policy_id"] = policy.policy_id);
		const response = await this.commonService.httpGetMethod(
			url,
			"application/json",
			true,
			paramData,
			"Declaration"
		);
		let ret = response.status == 0 ? response.data[0] || {} : {};
		if (JSON.stringify(ret) == "{}") {
			this.commonService.errorsmsg(
				response.txt || "Unable to get policy details",
				""
			);
		}
		return ret;
	}

	/*
	 * Created By : Sharann N
	 * Description : get endorsement data for particular policy.
	 *********************************************/
	async getEndorsementData(policy) {
		const url = `${this.commonVariablesService.baseURL}api/v2/endorsement/${policy.endorsement_id}`;
		const response = await this.commonService.httpGetMethod(
			url,
			"application/json",
			true,
			{},
			"Declaration"
		);
		let ret = response.status == 0 ? response.data[0] || {} : {};
		if (JSON.stringify(ret) == "{}") {
			this.commonService.errorsmsg(
				response.txt || "Unable to get policy details",
				""
			);
		}
		return ret;
	}

	/*
	 * Created By : Sharann N
	 * Description : load cancel certificate list to underwriter/helpdesk in datatable.
	 *********************************************/
	async loadCancelCertificateList(newArray:any="", statusArray, policy_no: any = "") {
		this.spinner.show();
		let actionData = [];

		const url = `${this.commonVariablesService.baseURL}api/v1/marine_declaration/cancel_certificate/list`;
		const params = {
			product_id: this.commonVariablesService.declarationProductId,
			email: window.localStorage.getItem("email") || "",
			uw_location: window.localStorage.getItem("uwLevelObj") || "{}",
			role: this.getUserType,
			channel_type: newArray,
			status_selected: statusArray,
			gc_policy_no: policy_no,
		};
		const responseCancel = await this.commonService.httpPostMethod(
			url,
			params,
			"application/json",
			true,
			"Declaration"
		);
		this.spinner.show();
		if (responseCancel.body.status === 0) {
			const responseData = [...responseCancel.body.data].reverse();
			for (const data of responseData) {
				actionData = [
					{
						navTo: 3,
						displayText: "View Draft / Certificate",
						valueText: "view_draft_cert",
					},
				];
				if (data.cancel_status == "open") {
					data.cancel_status = "-";
					actionData = [
						{
							navTo: 9,
							displayText: "Approve / Reject",
							valueText: "appr_rejt",
						},
					];
				}
				const endrosementData =
					(data.data.endrosement || [])[
						(data.data.endrosement || []).length - 1
					] ||
					"" ||
					{};
				const cancel_status = await this.commonService.convertToPastTense(
					data.cancel_status
				);
				this.declarationData.contentData.push({
					action: actionData,
					certificate_no: data.data.cust_fld_6
						? data.data.cust_fld_6
						: data.data.policy_no,
					certificate_date: this.datePipe.transform(
						data.data.c_ts,
						"dd-MM-yyyy"
					),
					certificate_date_obj: data.data.c_ts,
					uw_status: this.titlecasePipe.transform(cancel_status),
					req_date: this.datePipe.transform(data.c_ts, "dd-MM-yyyy"),
					req_date_obj: data.c_ts,
					declaration_type: this.titlecasePipe.transform(
						data.data.cust_fld_2 || "-"
					),
					referral_type: data.referral_type || "-",
					invoice_no:
						(endrosementData.endorsement_id || "") == ""
							? data.data.quote.data.invoice_no || "-"
							: endrosementData.eproposal.data.invoice_no || "-",
					policy_no: data.data.cust_fld_1,
					client_remarks: data.reason,
					insured_name:
						(endrosementData.endorsement_id || "") == ""
							? (data.data.quote.data.default_new_client || "").toLowerCase() ==
							  "yes"
								? data.data.quote.data.new_insured_name || "-"
								: data.data.quote.data.client_name ||
								  data.data.quote.data.broker_name ||
								  "-"
							: endrosementData.eproposal.data.client_name ||
							  endrosementData.eproposal.data.broker_name,
					cancel_status: data.cancel_status,
					dup_cert_policy_no: data.dup_cert_policy_no,
					policy_id: data.data.policy_id,
					quote_id: data.data.quote_id,
					master_policy_no: data.data.master_policy_no,
					sub_voyage_id: data.data.quote.data.sub_voyage_id,
					is_uw_certificate: true,
					assigned_to_level: data.assigned_to_level || "one",
					producer_branch_name: data.producer_branch_name || "",
					detailedPolicyData: { assigned_to: data.assigned_group },
					sme: data?.sme,
				});
			}
		} else if (responseCancel.body.status != -114) {
			this.commonService.errorsmsg(
				"Unable to load Cancel Certificate List Data ",
				""
			);
		}
	}

	/*
	 * Created By : Sharann N
	 * Description : to load certificate/bulk data in modal template.
	 *********************************************/
	async loadDraftCertificateList(selectedPolicyNo) {
		this.spinner.show();
		//$('#certificate_table').DataTable().destroy();
		const url = `${this.commonVariablesService.baseURL}api/v1/marine_declaration/list`;
		let policyRefNum = [];
		if ((this.header.policy_ref_num || "") != "") {
			policyRefNum.push(this.header.policy_ref_num);
		}
		let ref=window.localStorage.getItem("allPolicyrefNum");
		if(ref) {
			ref.split(',').forEach(value =>{
				policyRefNum.push(value);
			})
		}
		var that = this;
		(this.gcEndorsementDetails || []).forEach(function (value) {
			if (
				policyRefNum.indexOf(value.policy_ref_num) == -1 &&
				that.header.policy_start_date_dt == value.policy_inception_date &&
				(that.header.policy_end_date_dt == value.policy_expiry_date ||
					that.header.policy_end_date_endorsement == value.policy_expiry_date)
			)
				if (value.policy_code != "NC" && value.policy_code != "RC")
					policyRefNum.push(value.policy_ref_num);
		});

		policyRefNum =	policyRefNum.filter(function(item, pos){
			return policyRefNum.indexOf(item)== pos; 
		});

		
		/* (this.gcEndorsementDetails || []).forEach(function (value) {
      if (policyRefNum.indexOf(value.policy_ref_num) == -1) policyRefNum.push(value.policy_ref_num)
    }) */
		let paramData = {};

		paramData =
			this.certificateDraftHistoryForm.value.certificateDraftHistory ==
			"Issue Date"
				? {
						issue_date:
							this.datePipe.transform(
								this.certificateDraftHistoryForm.value.certificateFromDate,
								"yyyy-MM-dd"
							) +
							"," +
							this.datePipe.transform(
								this.certificateDraftHistoryForm.value.certificateToDate,
								"yyyy-MM-dd"
							),
				  }
				: this.certificateDraftHistoryForm.value.certificateDraftHistory ==
				  "Transaction Date"
				? {
						certificate_date:
							this.datePipe.transform(
								this.certificateDraftHistoryForm.value.certificateFromDate,
								"yyyy-MM-dd"
							) +
							"," +
							this.datePipe.transform(
								this.certificateDraftHistoryForm.value.certificateToDate,
								"yyyy-MM-dd"
							),
				  }
				: this.certificateDraftHistoryForm.value.certificateDraftHistory ==
				  "Invoice Number"
				? { invoice_no: this.certificateDraftHistoryForm.value.certificateTxt }
				: this.certificateDraftHistoryForm.value.certificateDraftHistory ==
				  "Certificate/Draft Number"
				? {
						draft_certificate_no:
							this.certificateDraftHistoryForm.value.certificateTxt,
				  }
				: this.certificateDraftHistoryForm.value.certificateDraftHistory ==
				  "Voyage Name"
				? { voyage_name: this.certificateDraftHistoryForm.value.certificateTxt }
				: {};
		const params = {
			gc_policy_no: selectedPolicyNo,
			declaration_type: "certificate",
			policy_ref_num: policyRefNum.toString(),
			...paramData,
		};
		const response = await this.commonService.httpGetMethod(
			url,
			"application/json",
			true,
			params,
			"Declaration"
		);
		if (response.status != 0 && response.status != -114) {
			this.commonService.errorsmsg(
				"Unable to load generated draft and certificate list ",
				""
			);
			return;
		}
		const responseData = [...response.data].reverse();

		/* let tmpUserType = this.cookie.get('userProfile'); */
		let tmpUserType = window.localStorage.getItem("userProfile");
		const userType = this.commonService.decryptData(tmpUserType);

		this.spinner.show();
		for (const detailedPolicyData of responseData) {
			const statusData = await this.commonService.findCertificateStatus(
				detailedPolicyData
			);
			const certificateStatus =
				statusData == "Cancelled-Certificate"
					? detailedPolicyData.status == 1
						? "Cancelled by endorsement"
						: detailedPolicyData.quote.cust_fld_10 == "2"
						? "Cancelled"
						: "Referred"
					: statusData == "On-Hold-Draft" ||
					  statusData == "Referred-Certificate"
					? "Referred"
					: statusData == "Rejected-Cancellation"
					? "Rejected"
					: statusData;
			let actionData = [
				{
					navTo: 3,
					displayText: "View Draft / Certificate",
					valueText: "view_draft_cert",
				},
			];
			if (
				userType.toLowerCase() == "produceruser" &&
				detailedPolicyData.producer_allow_certificate.toLowerCase() == "no"
			) {
				actionData = [
					{
						navTo: 3,
						displayText: "View Certificate",
						valueText: "view_cert",
					},
				];
			} else if (
				userType.toLowerCase() == "marineclaims" ||
				userType.toLowerCase() == "rm" ||
				userType.toLowerCase() == "helpdesk" ||
				userType.toLowerCase() == "ops" ||
				userType.toLowerCase() == "adminview"
			) {
				actionData = [
					{
						navTo: 3,
						displayText: "View Certificate",
						valueText: "view_cert",
					},
					{
						navTo: 6,
						displayText: "View History",
						valueText: "history",
					},
				];
			} else if (statusData == "Draft") {
				actionData = [
					{
						navTo: 3,
						displayText: "Accept / Delete Draft",
						valueText: "acc_del_draft",
					},
					{
						navTo: 8,
						displayText: "Modify Draft",
						valueText: "update_draft",
					},
					{
						navTo: 2,
						displayText: "Create Clone",
						valueText: "clone",
					},
					{
						navTo: 3,
						displayText: "View Draft",
						valueText: "view_draft_cert",
					},
				];
				if (
					this.getUserType == "underwriter" ||
					this.getUserType == "admin" ||
					this.getUserType == "hub"
				) {
					actionData = [
						{
							navTo: 3,
							displayText: "Accept / Delete Draft",
							valueText: "acc_del_draft",
						},
						{
							navTo: 8,
							displayText: "Modify Draft",
							valueText: "update_draft",
						},
						{
							navTo: 2,
							displayText: "Create Clone",
							valueText: "clone",
						},
						{
							navTo: 3,
							displayText: "View Draft",
							valueText: "view_draft_cert",
						},
						{
							navTo: 6,
							displayText: "View History",
							valueText: "history",
						},
					];
				}
			} else if (statusData == "Issued") {
				actionData = [
					{
						navTo: 9,
						displayText: "Cancel Certificate",
						valueText: "canc_cert",
					},
					{
						navTo: 10,
						displayText: "Update Certificate",
						valueText: "endorse-cert",
					},
					{
						navTo: 2,
						displayText: "Create Clone",
						valueText: "clone",
					},
					{
						navTo: 3,
						displayText: "View Certificate",
						valueText: "view_cert",
					},
				];
				if (
					this.getUserType == "underwriter" ||
					this.getUserType == "admin" ||
					this.getUserType == "hub"
				) {
					actionData = [
						{
							navTo: 9,
							displayText: "Cancel Certificate",
							valueText: "canc_cert",
						},
						{
							navTo: 10,
							displayText: "Update Certificate",
							valueText: "endorse-cert",
						},
						{
							navTo: 2,
							displayText: "Create Clone",
							valueText: "clone",
						},
						{
							navTo: 3,
							displayText: "View Certificate",
							valueText: "view_cert",
						},
						{
							navTo: 6,
							displayText: "View History",
							valueText: "history",
						},
					];
				}
			} else if (statusData == "Cancelled-Certificate") {
				actionData = [
					{
						navTo: 3,
						displayText: "View Certificate",
						valueText: "view_cert",
					},
				];
				if (
					this.getUserType == "underwriter" ||
					this.getUserType == "admin" ||
					this.getUserType == "hub"
				) {
					actionData = [
						{
							navTo: 3,
							displayText: "View Certificate",
							valueText: "view_cert",
						},
						{
							navTo: 6,
							displayText: "View History",
							valueText: "history",
						},
					];
				}
			} else if (statusData == "On-Hold-Draft") {
				actionData = [
					{
						navTo: 3,
						displayText: "View Draft",
						valueText: "view_draft_cert",
					},
				];
			} else if (
				statusData == "Rejected-Cancellation" ||
				statusData == "Referred-Certificate"
			) {
				actionData = [
					{
						navTo: 2,
						displayText: "Create Clone",
						valueText: "clone",
					},
					{
						navTo: 3,
						displayText: "View Certificate",
						valueText: "view_cert",
					},
				];
				if (
					this.getUserType == "underwriter" ||
					this.getUserType == "admin" ||
					this.getUserType == "hub"
				) {
					actionData = [
						{
							navTo: 2,
							displayText: "Create Clone",
							valueText: "clone",
						},
						{
							navTo: 3,
							displayText: "View Certificate",
							valueText: "view_cert",
						},
						{
							navTo: 6,
							displayText: "View History",
							valueText: "history",
						},
					];
				}
			}

			let validDate: any = new Date(detailedPolicyData.c_ts);
			validDate.setDate(validDate.getDate() + 7);
			const validUpto =
				statusData == "Draft"
					? this.datePipe.transform(validDate, "dd-MM-yyyy")
					: "-";
			//var getValidDate = validDate;
			validDate = validUpto != "-" ? validDate : "-";
			const endrosementData =
				(detailedPolicyData.endrosement || [])[
					detailedPolicyData.endrosement.length - 1
				] || {};
			let sampledate = detailedPolicyData.quote.data.invoice_date;
			/* let sampledate = ((endrosementData.endorsement_id || '') == '') ? detailedPolicyData.quote.data.invoice_date : detailedPolicyData.quote.data.invoice_date; */
			let myMoment: moment.Moment = moment(sampledate, "DD/MM/YYYY", true);
			const convertDate =
				myMoment["_d"] != "Invalid Date"
					? this.datePipe.transform(myMoment["_d"], "dd-MM-yyyy")
					: this.datePipe.transform(sampledate, "dd-MM-yyyy");
			const convertDateObj =
				myMoment["_d"] != "Invalid Date" ? myMoment["_d"] : sampledate;
			const qnstp_reason =
				(detailedPolicyData.qnstp_case || "").toUpperCase() == "YES"
					? (((detailedPolicyData.qnstp || {}).details || [])[0] || "")
							.reason || "-"
					: "-";
			let endr_index = (detailedPolicyData.endrosement || []).length
				? detailedPolicyData.endrosement[
						detailedPolicyData.endrosement.length - 1
				  ].endorsement_index
				: "";
			endr_index = endr_index == "" ? "" : "_" + ("0" + endr_index).slice(-2);
			this.declarationData.contentData.push({
				action: actionData,
				policy_no: `${selectedPolicyNo}`,
				certificate_date: this.datePipe.transform(
					detailedPolicyData.c_ts,
					"dd-MM-yyyy"
				),
				certificate_date_obj: detailedPolicyData.c_ts,
				req_date_obj: detailedPolicyData.c_ts,
				certificate_no: `${
					(detailedPolicyData.policy_no
						? detailedPolicyData.quote.cust_fld_6
							? detailedPolicyData.quote.cust_fld_6
							: detailedPolicyData.policy_no
						: detailedPolicyData.quote.cust_fld_5
						? detailedPolicyData.quote.cust_fld_5
						: detailedPolicyData.quote_id) + endr_index
				}`,
				insured_name:
					(
						detailedPolicyData.quote.data.default_new_client || ""
					).toLowerCase() == "yes"
						? detailedPolicyData.quote.data.new_insured_name || "-"
						: detailedPolicyData.quote.data.client_name ||
						  detailedPolicyData.quote.data.insured_name ||
						  detailedPolicyData.quote.data.broker_name ||
						  "-",
				invoice_no:
					(endrosementData.endorsement_id || "") == ""
						? detailedPolicyData.quote.data.invoice_no
						: endrosementData.eproposal.data.invoice_no,
				premium_amount: await this.decimalPt(
					(endrosementData.endorsement_id || "") == ""
						? detailedPolicyData.quote.data.net_premium_final
						: endrosementData.eproposal.data.net_premium_final
				),
				sum_insured: await this.decimalPt(
					(endrosementData.endorsement_id || "") == ""
						? detailedPolicyData.quote.data.total_si
						: endrosementData.eproposal.data.total_si
				),
				status: certificateStatus,
				quote_id: detailedPolicyData.quote_id,
				policy_id: detailedPolicyData.policy_id,
				master_policy_no: detailedPolicyData.master_policy_no,
				sub_voyage_id: detailedPolicyData.quote.data.sub_voyage_id,
				invoice_date: convertDate,
				invoice_date_obj: convertDateObj,
				issue_date: this.datePipe.transform(
					detailedPolicyData.quote.data.issue_date,
					"dd-MM-yyyy"
				),
				issue_date_obj: detailedPolicyData.quote.data.issue_date,
				valid_upto: validUpto,
				valid_upto_obj: validDate,
				uw_remarks:
					JSON.stringify(endrosementData) == "{}"
						? qnstp_reason
						: endrosementData.eproposal.data.eproposal_reason || "-",
				voyage_name:
					detailedPolicyData.quote.data.cust_fld_9 ||
					detailedPolicyData.quote.data.pol_voyage ||
					detailedPolicyData.quote.data.voyage_name,
					migrated_certificate:
					detailedPolicyData.quote.data.migrated_certificate == "1"
									? true
									: false,
				is_original_downloaded: [
					"ops",
					"helpdesk",
					"rm",
					"marineclaims",
				].includes(this.getUserType)
					? true
					: JSON.stringify(endrosementData) == "{}"
					? (
							(detailedPolicyData.data || {}).is_original_downloaded || ""
					  ).toLowerCase() == "yes"
						? true
						: false
					: (
							(detailedPolicyData.data || {})[
								`is_${endrosementData.endorsement_id || ""}_original_downloaded`
							] || ""
					  ).toLowerCase() == "yes"
					? true
					: false,
				eproposal_id:
					JSON.stringify(endrosementData) == "{}"
						? ""
						: endrosementData.eproposal_id || "",
				endorsement_id:
					JSON.stringify(endrosementData) == "{}"
						? ""
						: endrosementData.endorsement_id,
				is_endorsement: JSON.stringify(endrosementData) == "{}" ? false : true,
				endrosementData: endrosementData,
				detailedPolicyData: detailedPolicyData,
			});
		}
		//this.dtTrigger.next();
		this.spinner.hide();
	}

	/*
	 * Created By : Sharann N
	 * Description : To add the row span and to hide the cell in datatable (policy level).
	 *********************************************/
	rowSpanPolicyLevel(resp) {
		const ary = this.searchPipe.transform(this.certificateData, this.selected);
		for (let index = 0; index < ary.length; index++) {
			if (index != 0) {
				$(`#${resp.quote_id + index}`).remove();
			}
		}
		return ary.length;
	}

	/*
	 * Created By : Sharann N
	 * Description : To add the row span and to hide the cell in datatable (voyage level).
	 *********************************************/
	rowspan(resp, index) {
		let rowspan = 0;
		let rowNo = 0;
		const ary = this.searchPipe.transform(this.certificateData, this.selected);
		if(resp.risk_details_serial) {
			// Ticket No : 176527 Same voyage name changes start
			for (const obj of ary) {
				if (obj.voyage_name == resp.voyage_name  && obj.risk_details_serial == resp.risk_details_serial) {
					rowNo++;
					if (obj.sub_voyage_id == resp.sub_voyage_id) break;
				}
			}

			if (rowNo == 1) {
				for (const obj of ary) {
					if (
						obj.voyage_name == resp.voyage_name &&
						obj.master_policy_balance == resp.master_policy_balance && obj.risk_details_serial == resp.risk_details_serial
					)
						rowspan++;
				}
			} else {
				rowspan = 1;
				$(`#${resp.quote_id + index}SI`).remove();
			}

		} else {
			for (const obj of ary) {
				if (obj.voyage_name == resp.voyage_name  && obj.gc_running_id == resp.gc_running_id) {
					rowNo++;
					if (obj.sub_voyage_id == resp.sub_voyage_id) break;
				}
			}

			if (rowNo == 1) {
				for (const obj of ary) {
					if (
						obj.voyage_name == resp.voyage_name &&
						obj.master_policy_balance == resp.master_policy_balance && obj.gc_running_id == resp.gc_running_id
					)
						rowspan++;
				}
			} else {
				rowspan = 1;
				$(`#${resp.quote_id + index}SI`).remove();
			}
		}
		
		
		return rowspan;
	}

	/*
	 * Created By : Sharann N
	 * Description : to download pdf for the certificate.
	 *********************************************/
	async showPDF(type, data) {
		if (
			type == "policy-original" &&
			["ops", "helpdesk", "rm", "marineclaims"].includes(this.getUserType)
		)
			return;
		this.spinner.show();
		let ret: any = await this.commonService.downloadPdf(type, data);
		if (ret.status == 0) {
			$("#certificate_table").DataTable().destroy();
			await this.loadCompleteDeclarationData();
			this.spinner.hide();
			setTimeout(() => {
				this.spinner.hide();
			}, 7000);
		} else {
			this.commonService.errorsmsg(ret.data, "");
		}
	}

	/*
	 * Created By : Sharann N
	 * Description : get value with decimal point and `,` sepeartor.
	 *********************************************/
	decimalPt(value) {
		return new Promise(async (resolve) => {
			return resolve(
				value == "#VALUE?"
					? (0).toFixed(2)
					: Number(String(value).replace(/,/g, "").trim())
							.toFixed(2)
							.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
			);
		});
	}

	/*
	 * Created By : Sharann N
	 * Description : to assign values for declaration assigned to underwriter/helpdesk.
	 *********************************************/
	async assignToTable(response) {
		this.spinner.show();
		for (const obj of response) {
			const detailedData = obj.master_policy_data;
			const detailedPolicyData = obj.declaration_data;
			const endorsementData = obj.endorsement;
			// -1 is invalid master policy, 0 is valid policy, 1 is cancelled by endorsement
			const cust_fld_10 = detailedData.cust_fld_10 || "";
			const isValidPolicy = cust_fld_10 == "1" ? detailedData.status : -1;
			if (JSON.stringify(detailedPolicyData) == "{}") continue;
			let actionData = [];
			this.isUwCertificate =
				detailedPolicyData.quote.cust_fld_2.toLowerCase() == "certificate"
					? true
					: false;
			const idx = detailedPolicyData.qnstp.details.length;
			let nstp_status = endorsementData.endorsement_id
				? endorsementData.eproposal.data.eproposal_status || "-"
				: idx
				? detailedPolicyData.qnstp.details[idx - 1].nstp_status || "-"
				: "-";
			nstp_status = await this.commonService.convertToPastTense(nstp_status);
			if (this.isUwCertificate) {
				actionData = [
					{
						navTo: 3,
						displayText: "View Draft / Certificate",
						valueText: "view_draft_cert",
					},
				];
			} else {
				actionData = [
					{
						navTo: 5,
						displayText: "View Bulk Declaration",
						valueText: "view_bulk",
					},
				];
			}
			if (nstp_status == "-" && isValidPolicy > -1) {
				if (this.isUwCertificate) {
					actionData = [
						{
							navTo: 8,
							displayText: "Approve / Reject",
							valueText: "appr_rejt",
						},
					];
				} else {
					actionData = [
						{
							navTo: 5,
							displayText: "Upload excel / Approve / Reject",
							valueText: "upld_appr_rejt",
						},
					];
				}
			}
			const referralType = endorsementData.endorsement_id
				? this.isUwCertificate
					? "Update Certificate"
					: "On Hold"
				: detailedPolicyData.quote.data.referral_type || "-";
			const reqDateObj = endorsementData.endorsement_id
				? endorsementData.c_ts
				: detailedPolicyData.c_ts;
			const clientRemarks = ["Update Certificate", "On Hold"].includes(
				referralType
			)
				? endorsementData.eproposal.data.client_remarks ||
				  endorsementData.eproposal.data.reason_change ||
				  "-"
				: detailedPolicyData.quote.data.refferal_remark ||
				  detailedPolicyData.quote.data.referral_remark ||
				  "-";

			this.declarationData.contentData.push({
				action: actionData,
				is_valid_policy: isValidPolicy,
				endorsementData: endorsementData,
				detailedData: detailedData,
				certificate_no: detailedPolicyData.policy_no
					? detailedPolicyData.quote.cust_fld_6
						? detailedPolicyData.quote.cust_fld_6
						: detailedPolicyData.policy_no
					: detailedPolicyData.quote.cust_fld_5
					? detailedPolicyData.quote.cust_fld_5
					: detailedPolicyData.quote_id || "",
				policy_no: detailedPolicyData.quote.cust_fld_1,
				certificate_date: this.datePipe.transform(
					detailedPolicyData.c_ts,
					"dd-MM-yyyy"
				),
				certificate_date_obj: detailedPolicyData.c_ts,
				insured_name:
					detailedPolicyData.quote.data.default_new_client == "Yes"
						? detailedPolicyData.quote.data.new_insured_name
						: detailedPolicyData.quote.data.client_name ||
						  detailedPolicyData.quote.data.insured_name ||
						  detailedPolicyData.quote.data.broker_name ||
						  "-",
				invoice_no: detailedPolicyData.quote.data.invoice_no || "-",
				req_date: this.datePipe.transform(reqDateObj, "dd-MM-yyyy"),
				req_date_obj: reqDateObj,
				declaration_type: this.isUwCertificate
					? "Certificate"
					: (await this.findDeclarationType(
							detailedData,
							detailedPolicyData,
							detailedPolicyData.policy_no
								? detailedPolicyData.quote.cust_fld_6
									? detailedPolicyData.quote.cust_fld_6
									: detailedPolicyData.policy_no
								: detailedPolicyData.quote.cust_fld_5
								? detailedPolicyData.quote.cust_fld_5
								: detailedPolicyData.quote_id || ""
					  )) || "-",
				referral_type: referralType,
				client_remarks: clientRemarks,
				uw_status: this.titlecasePipe.transform(nstp_status),
				quote_id: detailedPolicyData.quote_id,
				policy_id: detailedPolicyData.policy_id,
				master_policy_no: detailedPolicyData.quote.cust_fld_3,
				sub_voyage_id: detailedPolicyData.quote.data.sub_voyage_id,
				is_uw_certificate: this.isUwCertificate,
				detailedPolicyData: detailedPolicyData,
				assigned_to_level: obj.assigned_to_level || "",
				producer_branch_name:
					detailedData.quote.data.producer_branch_name || "",
				sme: detailedData.quote?.data.sme,
			});
		}
	}

	/*
	 * Created By : Sharann N
	 * Description : check master policy is active or not.
	 *********************************************/
	async checkMasterPolicy(policyDetails) {
		let isMasterPolicyInactived = false;
		if (
			(this.getUserType == "underwriter" || this.getUserType == "helpdesk") &&
			this.pageContent == 0
		) {
			const masterPolicyDetails = await this.getPolicyData(policyDetails, true);
			this.masterPolicyRenewalCounter =
				masterPolicyDetails.quote.data.renewal_counter;
			isMasterPolicyInactived = masterPolicyDetails.status == 1 ? true : false;
		}
		if (isMasterPolicyInactived) {
			this.commonService.warningmsg("Master policy is deleted", "");
			this.spinner.hide();
			setTimeout(() => {
				this.spinner.hide();
			}, 7000);
			this.closeModal();
			return true;
		}
		return false;
	}

	/*
	 * Created By : Sharann N
	 * Description : check declaration is assigned to valid user/group or not.
	 *********************************************/
	async checkAssignee(index) {
		let valid = 0;
		if (!(this.getUserType == "underwriter" && this.pageContent == 0)) {
			return false;
		}
		const uwLevelObj = JSON.parse(
			window.localStorage.getItem("uwLevelObj") || "{}"
		);
		const validUser =
			uwLevelObj[
				this.declarationData.contentData[index].producer_branch_name
			].toLowerCase() ==
			this.declarationData.contentData[index].assigned_to_level
				? true
				: false;
		//if 'assigned to' is group
		if (
			validUser &&
			([
				this.commonVariablesService.uwLOneGrpCode,
				this.commonVariablesService.uwLTwoGrpCode,
				this.commonVariablesService.uwLThreeGrpCode,
			].includes(
				this.declarationData.contentData[index].detailedPolicyData.assigned_to
			) ||
				(window.localStorage.getItem("email") || "") ==
					this.declarationData.contentData[index].detailedPolicyData
						.assigned_to)
		) {
			valid = 1;
		}

		if (valid == 1) {
			window.localStorage.setItem(
				"uwLevel",
				this.declarationData.contentData[index].assigned_to_level
			);
			return false;
		} else {
			this.commonService.errorsmsg("Declaration is not assigned to you", "");
			return true;
		}
	}

	/*
	 * Created By : Sharann N
	 * Description : check declaration is assigned to valid user/group or not.
	 *********************************************/
	async formActiveMasterPolicies(type, forTableView) {
		/* const mailID = this.cookie.get('email');
    let tmpUserType = this.cookie.get('userProfile'); */
		const mailID = window.localStorage.getItem("email");
		let tmpUserType = window.localStorage.getItem("userProfile");
		const userType = this.commonService.decryptData(tmpUserType);

		let tempArrObj = [];
		let allowCert = "No";
		for (const obj of this.totalCertificateData || []) {
			for (const data of obj.data.data.producer_users) {
				if (data.email == mailID) {
					allowCert = data.allow_certificate;
					break;
				}
			}
			const isCertificate = type == "certificate" ? true : false;
			// check allow to generate certificate for producer
			if (
				isCertificate &&
				allowCert.toLowerCase() == "no" &&
				userType.toLowerCase() == "produceruser"
			) {
				continue;
			}
			obj["search_key"] = obj.data.cust_fld_1;
			if ((obj.data.data.sub_voyage || []).length > 0) {
				for (const dataObj of obj.data.data.sub_voyage) {
					const days = dataObj.days_post_expiry;
					//expiry change
					const dateObj = new Date((obj.data.cust_fld_2) ? obj.data.cust_fld_2 : obj.data.quote.data.gc_policy_end_date);
					dateObj.setDate(dateObj.getDate() + Number(days));
					const isNotExpiried =
						new Date().getTime() <= dateObj.getTime() ? true : false;
					const isMop =
						(obj.data.quote.data.policy_type || "").toUpperCase() == "MOP" ||
						(obj.data.quote.data.policy_type || "").toUpperCase() ==
							"OPEN COVER"
							? true
							: false;
					const isRateApplicable =
						obj.data.quote.data.voyage.rate_applicable.toUpperCase() == "YES"
							? true
							: false;
					const isVoyageInactive = isCertificate ? obj.status == 0 : true;
					if (
						isNotExpiried &&
						isVoyageInactive &&
						((!isMop &&
							dataObj.certificate_allowed == "Yes" &&
							isCertificate) ||
							(!isMop && isRateApplicable && !isCertificate) ||
							(isMop &&
								dataObj.certificate_bulk == "Certificate" &&
								isCertificate) ||
							(isMop &&
								dataObj.certificate_bulk != "Certificate" &&
								!isCertificate))
					) {
						const master_balc = isCertificate
							? obj.available_opening_balance_certificate || 0
							: obj.available_opening_balance_bulk || 0;
						const duplicateAry = tempArrObj.filter(
							(value) =>
								value.unique_key ==
								`${obj.data.quote.data.voyage.voyage_name}~${dataObj.sub_voyage_name}~${master_balc}~${obj.data.quote.data.voyage.risk_detail_serial ? obj.data.quote.data.voyage.risk_detail_serial : obj.data.quote.data.voyage.gc_running_id}`
						);
						if (duplicateAry.length) continue;
						const voyageName = await this.commonService.getVoyageDesc(
							obj.data.quote.data.voyage
						);
						tempArrObj.push({
							quote_id: obj.data.quote_id,
							policy_type: obj.data.quote.data.policy_type,
							cust_fld_1: obj.data.cust_fld_1,
							voyage_name: voyageName,
							sub_voyage_type: dataObj.sub_voyage_name,
							master_policy_balance: master_balc,
							declaration_type: isCertificate
								? "Certificate"
								: (
										obj.data.data.declaration_type_sub_voyage || ""
								  ).toUpperCase() == "BOTH"
								? dataObj.certificate_bulk
								: obj.data.data.declaration_type_sub_voyage,
							bulk_declaration_type: isCertificate
								? "Certificate"
								: dataObj.bulk_declaration_type,
							policy_start_date_dt: obj.data.quote.data.gc_policy_start_date,
							//expiry change
							policy_end_date_dt: (obj.data.cust_fld_2) ? obj.data.cust_fld_2 : obj.data.quote.data.gc_policy_end_date,
							insured_name:
								obj.data.quote.data.client_name ||
								obj.data.quote.data.insured_name ||
								obj.data.quote.data.broker_name ||
								"-",
							insured_branch: obj.data.quote.data.insured_branch,
							policy_id: obj.data.policy_id,
							policy_no: obj.data.policy_no,
							sub_voyage_id: dataObj.id,
							gc_running_id: obj.data.quote.data.voyage.gc_running_id,
							policy_ref_num: obj.data.quote.data.policy_ref_num,
							masterpolicy_status: obj.status,
							// Ticket No : 176527 Same voyage name changes start
							unique_key: `${obj.data.quote.data.voyage.voyage_name}~${dataObj.sub_voyage_name}~${master_balc}~${obj.data.quote.data.voyage.risk_detail_serial ? obj.data.quote.data.voyage.risk_detail_serial : obj.data.quote.data.voyage.gc_running_id}`,
							risk_details_serial: obj.data.quote.data.voyage.risk_detail_serial
						});
					}
				}
			}
		}

		console.log(tempArrObj)

		return tempArrObj;
	}

	selectCertificateFilterType() {
		this.submitted = false;
		if (
			this.certificateDraftHistoryForm.value.certificateDraftHistory !=
				"Issue Date" &&
			this.certificateDraftHistoryForm.value.certificateDraftHistory !=
				"Transaction Date"
		) {
			this.isShowCertificateTxt = true;
			this.isShowCertificateDate = false;
			this.certificateDraftHistoryForm
				.get("certificateTxt")
				.setValidators([Validators.required]);
			this.certificateDraftHistoryForm
				.get("certificateFromDate")
				.clearValidators();
			this.certificateDraftHistoryForm
				.get("certificateToDate")
				.clearValidators();
			this.certificateDraftHistoryForm.patchValue({
				certificateTxt: "",
			});
		} else {
			this.isShowCertificateTxt = false;
			this.isShowCertificateDate = true;
			this.certificateDraftHistoryForm.get("certificateTxt").clearValidators();
			this.certificateDraftHistoryForm
				.get("certificateFromDate")
				.setValidators([Validators.required]);
			this.certificateDraftHistoryForm
				.get("certificateToDate")
				.setValidators([Validators.required]);
		}
		this.certificateDraftHistoryForm
			.get("certificateTxt")
			.updateValueAndValidity();
		this.certificateDraftHistoryForm
			.get("certificateFromDate")
			.updateValueAndValidity();
		this.certificateDraftHistoryForm
			.get("certificateToDate")
			.updateValueAndValidity();
	}

	submitCertificateFilterData() {
		if (this.certificateDraftHistoryForm.invalid) {
			this.submitted = true;
			return;
		}
		this.loadCompleteDeclarationData();
	}
}
